import { type ObservabilityEvent } from './events';

/**
 * This configuration controls:
 * - enabled: whether the event is sent to FullStory
 * - sendProperties: whether the event sends properties to FullStory
 *
 * WHY: We need to control event properties in particular as there is a 5000/month limit we butt up against.
 */
export const FULLSTORY_CONFIG: Partial<
  Record<ObservabilityEvent | string, { enabled: boolean; sendProperties: boolean }>
> = {
  PACKING_SLIP_BATCH_ENTRY_FETCHED: { enabled: true, sendProperties: false },
  PACKING_SLIP_BATCH_ENTRY_FETCHED_ERROR: { enabled: true, sendProperties: false },
  PACKING_SLIP_BATCH_ENTRY_FETCHED_SUCCESS: { enabled: true, sendProperties: false },
  POST_DEVICE_EVENT: { enabled: true, sendProperties: false },
  POST_DEVICE_EVENT_ERROR: { enabled: true, sendProperties: false },
  POST_DEVICE_EVENT_SUCCESS: { enabled: true, sendProperties: false },
  RATE_REFRESH_LABEL_DRAWER_ADDRESS_CARD: { enabled: true, sendProperties: false },
  RATE_REFRESH_LABEL_DRAWER_ADDRESS_CARD_ERROR: { enabled: true, sendProperties: false },
  RATE_REFRESH_LABEL_DRAWER_ADDRESS_CARD_SUCCESS: { enabled: true, sendProperties: false },
  RATE_REFRESH_LABEL_DRAWER_CUSTOMS_ITEMS_CARD: { enabled: true, sendProperties: false },
  RATE_REFRESH_LABEL_DRAWER_CUSTOMS_ITEMS_CARD_ERROR: { enabled: true, sendProperties: false },
  RATE_REFRESH_LABEL_DRAWER_CUSTOMS_ITEMS_CARD_SUCCESS: { enabled: true, sendProperties: false },
  RATE_REFRESH_LABEL_DRAWER_CUSTOMS_OPTIONS_CARD: { enabled: true, sendProperties: false },
  RATE_REFRESH_LABEL_DRAWER_CUSTOMS_OPTIONS_CARD_ERROR: { enabled: true, sendProperties: false },
  RATE_REFRESH_LABEL_DRAWER_CUSTOMS_OPTIONS_CARD_SUCCESS: { enabled: true, sendProperties: false },
  RATE_REFRESH_LABEL_DRAWER_FOOTER: { enabled: true, sendProperties: false },
  RATE_REFRESH_LABEL_DRAWER_FOOTER_ERROR: { enabled: true, sendProperties: false },
  RATE_REFRESH_LABEL_DRAWER_FOOTER_SUCCESS: { enabled: true, sendProperties: false },
  RATE_REFRESH_LABEL_DRAWER_INSURANCE_CARD: { enabled: true, sendProperties: false },
  RATE_REFRESH_LABEL_DRAWER_INSURANCE_CARD_ERROR: { enabled: true, sendProperties: false },
  RATE_REFRESH_LABEL_DRAWER_INSURANCE_CARD_SUCCESS: { enabled: true, sendProperties: false },
  RATE_REFRESH_LABEL_DRAWER_OPEN: { enabled: true, sendProperties: false },
  RATE_REFRESH_LABEL_DRAWER_OPEN_ERROR: { enabled: true, sendProperties: false },
  RATE_REFRESH_LABEL_DRAWER_OPEN_SUCCESS: { enabled: true, sendProperties: false },
  RATE_REFRESH_LABEL_DRAWER_OPTIONS_CARD: { enabled: true, sendProperties: true },
  RATE_REFRESH_LABEL_DRAWER_OPTIONS_CARD_ERROR: { enabled: true, sendProperties: true },
  RATE_REFRESH_LABEL_DRAWER_OPTIONS_CARD_SUCCESS: { enabled: true, sendProperties: true },
  RATE_REFRESH_LABEL_DRAWER_PACKAGE_CARD: { enabled: true, sendProperties: true },
  RATE_REFRESH_LABEL_DRAWER_PACKAGE_CARD_ERROR: { enabled: true, sendProperties: true },
  RATE_REFRESH_LABEL_DRAWER_PACKAGE_CARD_SUCCESS: { enabled: true, sendProperties: true },
  RATE_REFRESH_LABEL_DRAWER_RATES_CARD: { enabled: true, sendProperties: false },
  RATE_REFRESH_LABEL_DRAWER_RATES_CARD_ERROR: { enabled: true, sendProperties: false },
  RATE_REFRESH_LABEL_DRAWER_RATES_CARD_SUCCESS: { enabled: true, sendProperties: false },
  RATE_REFRESH_LABEL_DRAWER_SHIPMENT_DATE_CARD: { enabled: true, sendProperties: false },
  RATE_REFRESH_LABEL_DRAWER_SHIPMENT_DATE_CARD_ERROR: { enabled: true, sendProperties: false },
  RATE_REFRESH_LABEL_DRAWER_SHIPMENT_DATE_CARD_SUCCESS: { enabled: true, sendProperties: false },
  RATE_REFRESH_ONBOARDING_INSURANCE_CARD: { enabled: true, sendProperties: false },
  RATE_REFRESH_ONBOARDING_INSURANCE_CARD_ERROR: { enabled: true, sendProperties: false },
  RATE_REFRESH_ONBOARDING_INSURANCE_CARD_SUCCESS: { enabled: true, sendProperties: false },
  RATE_REFRESH_ORDER_DETAILS_INSURANCE_CARD: { enabled: true, sendProperties: false },
  RATE_REFRESH_ORDER_DETAILS_INSURANCE_CARD_ERROR: { enabled: true, sendProperties: false },
  RATE_REFRESH_ORDER_DETAILS_INSURANCE_CARD_SUCCESS: { enabled: true, sendProperties: false },
  RATE_REFRESH_ORDER_DETAILS_OPTIONS_CARD: { enabled: true, sendProperties: true },
  RATE_REFRESH_ORDER_DETAILS_OPTIONS_CARD_ERROR: { enabled: true, sendProperties: true },
  RATE_REFRESH_ORDER_DETAILS_OPTIONS_CARD_SUCCESS: { enabled: true, sendProperties: true },
  RATE_REFRESH_ORDER_DETAILS_PACKAGE_CARD: { enabled: true, sendProperties: true },
  RATE_REFRESH_ORDER_DETAILS_PACKAGE_CARD_ERROR: { enabled: true, sendProperties: true },
  RATE_REFRESH_ORDER_DETAILS_PACKAGE_CARD_SUCCESS: { enabled: true, sendProperties: true },
  RATE_REFRESH_ORDER_DETAILS_SHIPMENT_DATE_CARD: { enabled: true, sendProperties: false },
  RATE_REFRESH_ORDER_DETAILS_SHIPMENT_DATE_CARD_ERROR: { enabled: true, sendProperties: false },
  RATE_REFRESH_ORDER_DETAILS_SHIPMENT_DATE_CARD_SUCCESS: { enabled: true, sendProperties: false },
  SHIPMENTS_CREATED_BY_FILTER_APPLIED_ERROR: { enabled: true, sendProperties: false },
  SHIPMENTS_CREATED_BY_FILTER_LOADED_ERROR: { enabled: true, sendProperties: false },
};
